module.exports = __webpack_public_path__ + "img/img3.92ff5934.png";